import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FootnoteComponent } from './footnote.component';

@NgModule({
  declarations: [FootnoteComponent],
  exports: [FootnoteComponent],
  imports: [CommonModule],
})
export class FootnoteModule {}
